import { getDataFromSSR } from "@/handlers/client/commonClient";
import { logger } from "@/utils/logging/log-util";
import dynamic from "next/dynamic";

import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";

import { useRouter } from "next/router";
import { useEffect, useState } from "react";
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const MGIDAAdsScript = dynamic(() => import("@/component/Ads/MGIDAdsScript"));
import { parseMatchDetails } from "@/utils/ipl";
import { sportsUtil } from "@/utils/sports";
import PointsTable from "@/component/TestSeries/PointsTable";
import AsiaCupFAQSchema from "@/component/SeoTags/AsiaCupFaq";
const SeriesOverview = dynamic(() =>
  import("@/component/TestSeries/SeriesOverview")
);
const SeriesList = dynamic(() => import("@/component/TestSeries/SeriesList"));
const SeriesStats = dynamic(() => import("@/component/TestSeries/SeriesStats"));

const SeriesCommonFooter = dynamic(() =>
  import("@/component/TestSeries/SeriesCommonFooter")
);

const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const GTMScript = dynamic(() => import("@/component/Ads/GTMScript"));
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const ItemsList = dynamic(() => import("@/component/SeoTags/ItemsList"));
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);

const AsiaCupPage = ({
  categoryNewsListData = null,
  isMobileDevice = false,
  matchData = null,
  faqData = null,
  currentTab = 1,
  statsData = null,
  pointsData = null,
}) => {
  const router = useRouter();
  const currentPath = router?.asPath;

  const [latestMatchData, setLatestMatchData] = useState(matchData);

  useEffect(() => {
    async function getLiveMatchData() {
      try {
        const timestamp = Date.now();
        const matchResponse = await getDataFromSSR(
          `/api/getLiveMatchDetails?matchId=${matchData?.id}&time=${timestamp}`
        );
        if (matchResponse && matchResponse?.data?.data) {
          const liveMatchData = parseMatchDetails(matchResponse?.data?.data);
          setLatestMatchData(liveMatchData);
        }
        if (currentTab == 3) {
          const commResponse = await getDataFromSSR(
            `/api/getLiveCommentary?matchid=${matchData?.id}&time=${timestamp}`
          );
          if (commResponse) {
            const commData = parseMatchDetails(matchData?.data?.data);
            setCommentary(commData);
          }
        }
      } catch (err) {
        logger.error(err);
      }
    }

    if (matchData.status == "LIVE") {
      getLiveMatchData();
      const interval = setInterval(() => {
        getLiveMatchData();
      }, 10000);
      return () => clearInterval(interval);
    }
  }, []);

  const keyBindings = {
    Category:
      currentPath.split("/").length > 2
        ? [currentPath.split("/")[1], currentPath.split("/")[2]]
        : currentPath.split("/")[1],
    Keywords: categoryNewsListData?.seo_detail?.meta_keyword.split(","),
  };
  const [scrolled, setScrolled] = useState(true);
  // useEffect(() => {
  //   async function onFirstScroll() {
  //     if (!scrolled) {
  //       setScrolled(true);
  //     }
  //   }

  //   function handleScroll() {
  //     onFirstScroll();

  //     window.removeEventListener("scroll", handleScroll);
  //   }

  //   window.addEventListener("scroll", handleScroll);
  // }, []);
  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1659434453897-0"
              )
              .addService(googletag.pubads());
          }
          scrolled &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF-1_300x250",
                [300, 250],
                "div-gpt-ad-1659434604998-0"
              )
              ?.addService(googletag.pubads());
          scrolled &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0"
              )
              .addService(googletag.pubads());

          scrolled &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                [320, 50],
                "div-gpt-ad-1659435612077-0"
              )
              .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
          scrolled &&
            googletag?.cmd.push(function () {
              var INTERSTITIALAd = googletag
                ?.defineOutOfPageSlot(
                  "/1007232/News_tak_Mobile_HP_Mweb_Interstitial",
                  googletag?.enums.OutOfPageFormat.INTERSTITIAL
                )
                ?.addService(googletag.pubads());
              INTERSTITIALAd && googletag?.display(INTERSTITIALAd);
            });
        });
      } else {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659424515060-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1707804176041-1"
              )
              .addService(googletag.pubads());
          }

          scrolled &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-2"
              )
              ?.addService(googletag.pubads());
          scrolled &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
        });
      }
      if (scrolled) {
        if (typeof window !== "undefined" && window.apstag) {


          window.apstag?.fetchBids(
            {
              slots:
                window.screen.width < 900
                  ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
                  : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
              timeout: 2e3,
            },
            apstagBidCallback
          );
        }
      }
    }, 10);
  }, [scrolled]);

  const dynamicData = sportsUtil({
    fetchSID: false,
    matchData: matchData[0],
    sname: "asiacup2025",
    currentTab: currentTab,
    isLive: false,
    currentPath: currentPath,
  });
  const { title, description, keywords, canonical } = dynamicData;
  const breadCrumbs = dynamicData?.breadcrumb;
  const h1Text = dynamicData?.h1;

  return (
    <div>
      <HeadTag
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
        noAuthorTag={false}
        image={categoryNewsListData?.seo_detail?.og_image}
        lcpImage={`${categoryNewsListData?.content?.[0]?.image_small}?size=360:203`}
      />
      <GTMScript isElection={true} />
      <AsiaCupFAQSchema />
      <WebpageSchema
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
      />
      <BreadcrumbSchema breadcrumbList={breadCrumbs} />

      <ItemsList data={categoryNewsListData?.content} />
      <Breadcrumb breadcrumbList={breadCrumbs} />
      <MGIDAAdsScript delay={true} />
      <section className="px-4 py-2">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />

        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="728px"
          minHeight="90px"
        />
        {/* match banner + nav  */}
        <h1 className="my-4 font-semibold text-md md:text-lg">{h1Text}</h1>
        <div
          className="bg-cover bg-center w-[108%] -mx-4 md:w-full md:-mx-0 h-fit md:rounded-t-lg py-2 px-2 md:px-4 text-white"
          style={{ backgroundImage: 'url("https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prodMatchBanner.png")' }}
        >
          <div className="px-2 md:px-6 py-2 mt-4 flex items-center justify-between">
            <div className="flex flex-col items-start gap-1">
              <h2 className="flex flex-col items-start  text-2xl font-extralight">
                {!isMobileDevice && (
                  <span className="hidden md:block">Asia Cup 2025</span>
                )}
                {/* {!isMobileDevice && (
                  <span className="hidden md:block font-semibold"> 2025</span>
                )} */}
                {isMobileDevice && (
                  <span className="md:hidden">Asia Cup 2025</span>
                )}
                {/* {isMobileDevice && (
                  <span className="md:hidden">
                    {" "}
                    <span className="font-semibold"> 2025</span>
                  </span>
                )} */}
              </h2>
              <div className="flex gap-2 text-sm mt-4 items-center">
                <span>T20</span>
                <div className="bg-white rounded-full w-1 h-1"></div>
                <span>09 Sep - 28 Sep</span>
              </div>
            </div>
            <img
              src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/asiacuplogo.png"
              alt="asia cup logo"
              width={100}
              height={100}
            />
          </div>

          <div className="relative flex items-center justify-start -ml-3 md:-ml-0 gap-2 md:gap-4 text-md text-white pl-4 mt-2 -mb-2">
            <a
              className={`p-2 ${currentTab == 1 ? "border-b-4 border-primary" : ""
                }`}
              href={"/sports/asia-cup-2025"}
            >
              Overview
            </a>
            <a
              className={`p-2 ${currentTab == 2 ? "border-b-4 border-primary" : ""
                }`}
              href={"/sports/asia-cup-2025/stats"}
            >
              Stats
            </a>
            <a
              className={`p-2 ${currentTab == 4 ? "border-b-4 border-primary" : ""
                }`}
              href={"/sports/asia-cup-2025/points-table"}
            >
              Points Table
            </a>
            <a
              className={`p-2 ${currentTab == 3 ? "border-b-4 border-primary" : ""
                }`}
              href={"/sports/asia-cup-2025/match-schedule-fixtures-and-results"}
            >
              Matches
            </a>
          </div>
        </div>

        <div className="py-4 w-full">
          {currentTab == 1 && (
            <SeriesOverview
              matchData={matchData}
              statsData={statsData}
              pointsData={pointsData}
              scrolled={scrolled}
            />
          )}
          {currentTab == 2 && (
            <SeriesStats statsData={statsData} scrolled={scrolled} />
          )}
          {currentTab == 3 && (
            <SeriesList matchData={matchData} scrolled={scrolled} />
          )}
          {currentTab == 4 && (
            <PointsTable pointsData={pointsData} scrolled={scrolled} />
          )}
        </div>
        {
          <SeriesCommonFooter
            categoryNewsListData={categoryNewsListData}
            faqData={faqData}
            isMobileDevice={isMobileDevice}
            showAds={false}
            scrolled={scrolled}
            customHeading={"रिलेटेड न्यूज"}
            showContent={true}
          />
        }
        {scrolled && (
          <div className="mx-4">
            <AdSlot300x250
              divId={"div-gpt-ad-1659435474737-0"}
              minWidth="300px"
              minHeight="250px"
            />
          </div>
        )}

        {scrolled && (
          <AdSlot728x90
            divId="div-gpt-ad-1659425743360-0"
            minWidth="720px"
            minHeight="90px"
          />
        )}
        <div data-type="_mgwidget" data-widget-id="1584885"></div>
        <script
          async
          dangerouslySetInnerHTML={{
            __html: `window.addEventListener("load", function() {
          (function(w,q){w[q]=w[q]||[];w[q].push(["_mgc.load"])})(window,"_mgq");
        });`,
          }}
        ></script>
      </section>
    </div>
  );
};

export default AsiaCupPage;
